$(() => {
  const $topBtn = $('.js-pagetop');

  $topBtn.click(() => {
    $('body,html').animate({ scrollTop: 0 }, 500);
    return false;
  });
});
